import Card from "components/Card/Card";
import React, { useEffect, useState } from "react";
import Select from "react-select";
import moment from "moment";
import NotificationSystem from "react-notification-system";

import {
  Button,
  Grid,
  Table,
  OverlayTrigger,
  Tooltip,
  Pagination,
  Modal,
  Alert,
  Col,
  FormGroup,
  ControlLabel,
  FormControl,
  Row,
} from "react-bootstrap";
import LoadingSpinner from "views/Components/loadingSpinner";
import {
  GetAllLightHouseCategories,
  addLightHouseCategory,
  GetCategoriesById,
  updateLightHouseCategory,
  LoginLightHouse,
} from "Listfunction";
import Swal from "sweetalert2";
import { deleteLightHouseCategory } from "Listfunction";

const ViewLightHouseCategory = (props) => {
  var token = JSON.parse(localStorage.getItem("user"));
  const obj = token.token;
  const _notificationSystem = React.createRef();
  const [noRecordFound, setnoRecordFound] = useState(false);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPage, setTotalPage] = useState();
  const [categoryList, setCategoryList] = useState();
  const [subCategoryList, setSubCategoryList] = useState();
  const [addCategoryModalShow, setAddCategoryModalShow] = useState(false);
  const [categoryTitle, setCategoryTitle] = useState();
  const [categoryDataById, setCategoryDataById] = useState();
  const [categoryError, setCategoryError] = useState(null);
  const [isUpdateModal, setIsUpdateModal] = useState(false);
  const [categoryId, setCategoryId] = useState();
  const [addSubCategoryTableModalShow, setAddSubCategoryTableModalShow] =
    useState();
  const [subCategoryById, setSubCategoryById] = useState([]);
  const [isNoRecords, setIsNoRecords] = useState(false);

  let LgtToken = localStorage.getItem("lightHouseToken");

  useEffect(() => {
    setLoading(true);

    const loginCredentials = {
      email: "umar@gmail.com",
      password: "12345",
    };

    GetAllLightHouseCategories(LgtToken, currentPage)
      .then((res) => {
        setLoading(true);
        setCurrentPage(res.data.first_page_url);
        setTotalPage(res.data.last_page);
        const categories = res.data.data;
        setCategoryList(categories);
        const subCategory = categories.map((subCategories) => {
          return subCategories.sub_category;
        });
        setSubCategoryList(subCategory);
        setLoading(false);
      })
      .catch(async (err) => {
        if (err.response.status === 401) {
          const res = await LoginLightHouse(loginCredentials);
          localStorage.setItem("lightHouseToken", res.data.token);
        } else {
          console.log(err);
        }
      });
  }, []);

  const handleCategoryTitleOnchange = (e) => {
    setCategoryError(null);
    setCategoryTitle(e.target.value);
  };

  const handleAddCategorySubmit = async () => {
    if (categoryTitle === undefined) {
      setCategoryError(
        <div class="alert alert-danger" role="alert">
          Category Title Required
        </div>
      );
    } else if (!isUpdateModal) {
      setCategoryError(null);
      const addCategoryTitleBody = {
        title: categoryTitle,
        status: true,
      };
      const notification = _notificationSystem.current;
      try {
        const res = await addLightHouseCategory(addCategoryTitleBody, LgtToken);
        if (res.success === true) {
          notification.addNotification({
            title: <span data-notify="icon" className="pe-7s-gift"></span>,
            message: (
              <div>
                <b>Category</b> - Created Successfully .
              </div>
            ),
            level: "success",
            position: "bl",
            autoDismiss: 15,
          });
          setAddCategoryModalShow(false);

          GetAllLightHouseCategories(LgtToken, currentPage)
            .then((res) => {
              setCurrentPage(res.data.first_page_url);
              setTotalPage(res.data.last_page);
              const categories = res.data.data;
              setCategoryList(categories);
              const subCategory = categories.map((subCategories) => {
                return subCategories.sub_category;
              });
              setSubCategoryList(subCategory);
              setLoading(false);
            })
            .catch((err) => {
              console.log(err);
            });
        }
      } catch (err) {
        console.log("err", err);
        notification.addNotification({
          title: <span data-notify="icon" className="pe-7s-gift"></span>,
          message: (
            <div>
              <b>something went wrong</b>
            </div>
          ),
          level: "error",
          position: "bl",
          autoDismiss: 15,
        });
      }
    } else {
      setCategoryError(null);
      const updateCategoryTitleBody = {
        title: categoryTitle,
        status: true,
      };
      const notification = _notificationSystem.current;
      try {
        const res = await updateLightHouseCategory(
          updateCategoryTitleBody,
          categoryId,
          LgtToken
        );
        if (res.success === true) {
          notification.addNotification({
            title: <span data-notify="icon" className="pe-7s-gift"></span>,
            message: (
              <div>
                <b>Category</b> - Updated Successfully .
              </div>
            ),
            level: "success",
            position: "bl",
            autoDismiss: 15,
          });
          setAddCategoryModalShow(false);

          GetAllLightHouseCategories(LgtToken, currentPage)
            .then((res) => {
              setCurrentPage(res.data.first_page_url);
              setTotalPage(res.data.last_page);
              const categories = res.data.data;
              setCategoryList(categories);
              const subCategory = categories.map((subCategories) => {
                return subCategories.sub_category;
              });
              setSubCategoryList(subCategory);
              setLoading(false);
            })
            .catch((err) => {
              console.log(err);
            });
        }
      } catch (err) {
        notification.addNotification({
          title: <span data-notify="icon" className="pe-7s-gift"></span>,
          message: (
            <div>
              <b>something went wrong</b>
            </div>
          ),
          level: "error",
          position: "bl",
          autoDismiss: 15,
        });
      }
    }
  };

  const openEditCategoryModal = (id) => {
    setAddCategoryModalShow(true);
    setIsUpdateModal(true);
    setCategoryError(null);
    setCategoryId(id);
    GetCategoriesById(LgtToken, id)
      .then((res) => {
        const categories = res.data;
        console.log("first", categories);
        setCategoryDataById(categories);
        setCategoryTitle(res.data.title);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleAddCaddCategoryButtonClick = () => {
    setAddCategoryModalShow(true);
    setIsUpdateModal(false);
    setCategoryTitle(undefined);
    setCategoryError(null);
  };
  const showSubCategoryListModal = (id, sub_categories) => {
    if (sub_categories.length > 0) {
      setSubCategoryById(sub_categories);
      setIsNoRecords(false);
    } else {
      setIsNoRecords(true);
    }
    setAddSubCategoryTableModalShow(true);
  };

  const handleRemoveClick = (id) => {
    Swal.fire({
      width: "500px",
      title: "<strong><font size='36px'>Are Sure</font></strong>",
      icon: "info",
      html: "<font size='4px'>You want to remove this category </font>",
      showCloseButton: true,
      showCancelButton: true,
      focusConfirm: false,
      confirmButtonText: "<font size='4px'>Yes</font>",
      cancelButtonText: "<font size='4px'>No</font>",
    }).then(async (result) => {
      if (result.isConfirmed) {
        const notification = _notificationSystem.current;
        const res = await deleteLightHouseCategory(LgtToken, id);
        if (res.success === true) {
          notification.addNotification({
            title: <span data-notify="icon" className="pe-7s-gift"></span>,
            message: (
              <div>
                <b>Category</b> - Removed Successfully .
              </div>
            ),
            level: "success",
            position: "bl",
            autoDismiss: 15,
          });
          setLoading(true);
          GetAllLightHouseCategories(LgtToken, currentPage)
            .then((res) => {
              setCurrentPage(res.data.first_page_url);
              setTotalPage(res.data.last_page);
              const categories = res.data.data;
              setCategoryList(categories);
              const subCategory = categories.map((subCategories) => {
                return subCategories.sub_category;
              });
              setSubCategoryList(subCategory);
              setLoading(false);
            })
            .catch((err) => {
              console.log(err);
            });
        }
      }
    });
  };

  const paginationOnChange = async (LgtToken, number) => {
    setLoading(true);
    const res = await GetAllLightHouseCategories(LgtToken, number);

    setCategoryList(res.data.data);
    setCurrentPage(res.data.current_page);
    setTotalPage(res.data.last_page);
    setLoading(false);
  };

  let active = currentPage;
  let items = [];
  for (let number = 1; number <= totalPage; number++) {
    items.push(
      <Pagination.Item
        onClick={() => paginationOnChange(LgtToken, number)}
        active={number === active}
      >
        {number}
      </Pagination.Item>
    );
  }

  const subCategory = <Tooltip id="remove">Sub Category</Tooltip>;
  const remove = <Tooltip id="remove">Remove</Tooltip>;
  const edit = <Tooltip id="edit">Edit</Tooltip>;

  return (
    <>
      <Grid fluid>
        <Col xs={12} sm={12} md={12} lg={12}>
          <NotificationSystem ref={_notificationSystem} />
          <Row>
            <Col xs={4} sm={4} md={4} lg={4} className="text-left">
              <FormControl
                style={{ position: "relative", marginTop: "25px" }}
                name="search"
                placeholder="Search"
                type="text"
                className="text-input"
              />
            </Col>
            <Col xs={2} sm={2} md={2} lg={2} className="text-left">
              <Button
                style={{ marginTop: "25px" }}
                className="fl_mb_web_1 btn-fill fl_mb_1 w_150 btn-color"
              >
                Reset
              </Button>
            </Col>
            <Col xs={6} sm={6} md={6} lg={6} className="text-right">
              <Button
                style={{ marginTop: "25px" }}
                className="fl_mb_web_1 btn-fill fl_mb_1 w_150 btn-color"
                onClick={() => handleAddCaddCategoryButtonClick()}
              >
                Add Category <i className="fa fa-plus"></i>
              </Button>
              <br />
              &nbsp;
            </Col>
          </Row>
        </Col>
        <br />
        <Col md={12}>
          <Card
            content={
              <>
                <React.Fragment>
                  <Table responsive>
                    <thead>
                      <tr>
                        <th>ID</th>
                        <th>Category</th>
                        <th style={{ textAlign: "end" }}>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {loading ? (
                        <tr>
                          <td>
                            <LoadingSpinner />
                          </td>
                        </tr>
                      ) : noRecordFound ? (
                        <tr>
                          <td colspan="10">
                            <center>No record found</center>
                          </td>
                        </tr>
                      ) : (
                        <React.Fragment>
                          {categoryList &&
                            categoryList.map((item, i) => (
                              <>
                                <tr>
                                  <td>{item.id}</td>
                                  <td>{item.title}</td>
                                  <td style={{ textAlign: "end" }}>
                                    <OverlayTrigger
                                      placement="top"
                                      overlay={subCategory}
                                    >
                                      <Button
                                        simple
                                        bsStyle="info"
                                        bsSize="xs"
                                        style={{ border: "none" }}
                                        onClick={() =>
                                          showSubCategoryListModal(
                                            item.id,
                                            item.sub_category
                                          )
                                        }
                                      >
                                        <i class="fa  fa-bell" />
                                      </Button>
                                    </OverlayTrigger>
                                    &nbsp;
                                    <OverlayTrigger
                                      placement="top"
                                      overlay={edit}
                                    >
                                      <Button
                                        simple
                                        bsStyle="info"
                                        bsSize="xs"
                                        style={{ border: "none" }}
                                        onClick={() => {
                                          openEditCategoryModal(item.id);
                                        }}
                                      >
                                        <i class="fa fa-pencil" />
                                      </Button>
                                    </OverlayTrigger>
                                    &nbsp;
                                    <OverlayTrigger
                                      placement="top"
                                      overlay={remove}
                                    >
                                      <Button
                                        simple
                                        bsStyle="danger"
                                        bsSize="xs"
                                        style={{ border: "none" }}
                                        onClick={() => {
                                          handleRemoveClick(item.id);
                                        }}
                                      >
                                        <i class="fa fa-times" />
                                      </Button>
                                    </OverlayTrigger>
                                  </td>
                                </tr>
                              </>
                            ))}
                        </React.Fragment>
                      )}
                    </tbody>
                  </Table>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <Pagination bsSize="medium">{items}</Pagination>
                  </div>
                </React.Fragment>
              </>
            }
          />
        </Col>
      </Grid>
      <Modal
        show={addCategoryModalShow}
        onHide={() => setAddCategoryModalShow(false)}
        bsSize="large"
        allowFullScreen
      >
        <Modal.Header>
          <Modal.Title>
            {" "}
            {isUpdateModal ? "Edit Category" : "Add Category"}
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Row>
            <Col sm={7} md={7} xs={7}>
              <ControlLabel>Category Title</ControlLabel>
              <FormGroup>
                <FormControl
                  type="text"
                  value={categoryTitle}
                  name="title"
                  placeholder="Enter the category title "
                  onChange={(e) => handleCategoryTitleOnchange(e)}
                />
              </FormGroup>
              {categoryError}
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Button
            bsStyle="danger"
            fill
            onClick={() => setAddCategoryModalShow(false)}
          >
            Cancel
          </Button>
          <Button
            bsStyle="success"
            fill
            onClick={() => handleAddCategorySubmit()}
          >
            Submit
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal
        show={addSubCategoryTableModalShow}
        onHide={() => setAddSubCategoryTableModalShow(false)}
        bsSize="large"
        allowFullScreen
      >
        <Modal.Header>
          <Modal.Title>Sub Category List</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Table responsive style={{ overflowY: "scroll" }}>
            <thead>
              <tr>
                <th>Id</th>
                <th>Sub Category</th>
                <th>Notify dates</th>
              </tr>
            </thead>
            <tbody>
              {isNoRecords ? (
                <tr>
                  <td colspan="3">
                    <center>No record found</center>
                  </td>
                </tr>
              ) : (
                subCategoryById.map((list) => (
                  <tr>
                    <td>{list.id}</td>
                    <td>{list.title}</td>
                    <td>{list.notify_dates}</td>
                  </tr>
                ))
              )}
            </tbody>
          </Table>
        </Modal.Body>
        <Modal.Footer>
          <Button
            bsStyle="danger"
            fill
            onClick={() => setAddSubCategoryTableModalShow(false)}
          >
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ViewLightHouseCategory;
